/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import SharingTooltipStyles from './SharingTooltipStyles.module.scss';
import { IconButton } from '@/components/IconButton/IconButton';
import { SocialSharingIcon } from './SocialSharingIcon';
import NextImage from '@/components/NextImage';
import { CMSLink } from '@/features/contentstack/components/CMSLink/CMSLink';
import { Tooltip, View } from '@az/starc-ui';
import { useLabels } from '@/hooks/useLabels';
import { useContentStackBlogMenuNavigationData } from '../api/getContentStackBlogMenuNavigationData';

const labelMap = {
  SocialSharingTooltipHeading: 'label_BLOG_SocialSharingTooltipHeading',
};
type SocialSharingToolTipProps = {
  svgSize?: number;
  iconButtonClasses?: string;
  align?: 'start' | 'end' | 'center';
  justify?: 'start' | 'end' | 'center';
};

export const SharingTooltip = ({
  svgSize,
  iconButtonClasses,
  align,
  justify,
}: SocialSharingToolTipProps) => {
  const { data } = useContentStackBlogMenuNavigationData();
  const labels = useLabels(labelMap);
  return (
    <View align={align || 'end'} justify={justify || 'start'}>
      <Tooltip
        placement="bottom"
        headerText={labels.SocialSharingTooltipHeading}
        svg={SocialSharingIcon}
        svgSize={svgSize || 4}
        inline={true}
        width={800}
      >
        <View className={SharingTooltipStyles.iconStyle}>
          {data?.social_share_tooltip?.map((item, index) => (
            <CMSLink to={item?.social_media_link || ''} key={index}>
              <IconButton className={iconButtonClasses}>
                <NextImage src={item?.image?.image_url || ''} alt="" height={24} width={24} />
              </IconButton>
            </CMSLink>
          ))}
        </View>
      </Tooltip>
    </View>
  );
};
